export default "__VITE_ASSET__OqJgh5bU__"